// extracted by mini-css-extract-plugin
module.exports = {"Success":"Success___fvOBz","resourceInfo":"resourceInfo___3VbzX","buttons":"buttons___3Lqb3"};